import React, { Component } from "react";

import { Card, CardBody, Wrapper } from "app/NativeComponents/common";

import PropertyTags from "./PropertyTags";
import Lists from "./Lists";

class ListAndTags extends Component {
  componentDidUpdate(prevProps) {}

  render() {
    if (
      this.props.active_property.deal &&
      this.props.active_property.deal.removed != 1
    ) {
      return (
        <Card>
          <Lists {...this.props} />
          <PropertyTags {...this.props} />
        </Card>
      );
    }

    return <Wrapper />;
  }
}

export default ListAndTags;
